// The brand accent, in one place. Change these four values and every accent
// in the app follows — Tailwind classes and inline styles alike.
//
// `tailwind.config.js` requires this file to build the `accent`,
// `accent-hover`, `accent-on-light` and `accent-ink` colour utilities, and the
// handful of components that set colours through `style={{ }}` import the same
// constants. That is why this is CommonJS: the Tailwind config is a CJS module
// and cannot `import`.
//
// Two tones, because one colour cannot serve both surfaces:
//
//   ACCENT          bright, for dark sections   — 11.2:1 on #010810
//   ACCENT_ON_LIGHT darkened, for white sections — 5.1:1 on white
//   ACCENT_INK      near-black label for use on top of a filled accent button
//
// ACCENT on white is 1.8:1, which is illegible, so never reach for it there.

const ACCENT = "#F0B90A";
const ACCENT_HOVER = "#D1A008";
const ACCENT_ON_LIGHT = "#8A6A00";
const ACCENT_INK = "#1B2129";

module.exports = { ACCENT, ACCENT_HOVER, ACCENT_ON_LIGHT, ACCENT_INK };
